import { gql } from "@apollo/client";

export const LIST_VATS = gql`
  query listVats($limit: Int, $offset: Int, $orderBy: [String!], $filter: VatFilter) {
    listVats(filter: $filter) {
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        id
        rate
        ratePercentage
        name
        editable
        code
        companyVatStatus {
          id
          active
        }
        active
      }
      totalCount
    }
  }
`;

export const LIST_VATS_FOR_ASYNC_SELECT = gql`
  query listVats(
    $companyId: ID!
    $onlyCompany: Boolean
    $activeOnly: Boolean
    $search: String
    $offset: Int
    $limit: Int
    $orderBy: [String!]
  ) {
    listVats(
      filter: {
        search: $search
        onlyCompany: $onlyCompany
        activeOnly: $activeOnly
        companyId: $companyId
      }
    ) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        rate
        ratePercentage
        name
        code
      }
    }
  }
`;
export const LIST_UNIT_MEASURES_FOR_ASYNC_SELECT = gql`
  query listUnitMeasures(
    $companyId_In: [ID]
    $search: String
    $offset: Int
    $limit: Int
    $orderBy: [String!]
  ) {
    listUnitMeasures(filter: { name_Startswith: $search, companyId_In: $companyId_In }) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        name
        slug
      }
    }
  }
`;

export const CREATE_VAT = gql`
  mutation createVat($input: CreateVatInput!) {
    createVat(input: $input) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const UPDATE_VAT = gql`
  mutation updateVat($input: UpdateVatInput!) {
    updateVat(input: $input) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const DELETE_VAT = gql`
  mutation deleteVat($id: ID!) {
    deleteVat(id: $id) {
      errors {
        field
        messages
      }
      success
    }
  }
`;
export const ACTIVATE_VAT = gql`
  mutation activateVat($input: VatActivateInput!) {
    activateVat(input: $input) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const GET_VAT = gql`
  query getVat($id: ID!) {
    getVat(id: $id) {
      id
      rate
      ratePercentage
      name
      editable
      code
      companyVatStatus {
        id
        active
      }
    }
  }
`;
